import React from 'react'
import styled from "styled-components"
import SliderSmall from "./slider-small"
import SliderLarge from "./slider-large"
import { graphql, useStaticQuery } from "gatsby"

const query = graphql`
  {
    allFile(
      filter: { relativeDirectory: { eq: "testimonials" } }
      sort: { fields: name }
    ) {
      nodes {
        relativeDirectory
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`

const Testimonials = () => {
  const data = useStaticQuery(query)
  const {
    allFile: { nodes: images },
  } = data
  return (
    <>
      <Wrapper>
        <h2>Everybody’s talking about Shopify Systems!</h2>
        <p>Find our what our previous clients have to say about our work</p>
      </Wrapper>
      <SliderSmall />
      <SliderLarge images={images}/>
    </>
  )
}

const Wrapper = styled.section`
  margin-top: 100px;
  margin-bottom: 20px;
  padding: 26px 20px;
  
  h2 { font-size: 30px; line-height: 47px; } 
  p { font-size: 12px; line-height: 190%; }
  @media screen and (min-width: 360px) { padding: 25px 57px; }
  @media screen and (min-width: 768px) { padding: 25px 77px; }
  @media screen and (min-width: 1024px) { margin: 100px 129px; }
  @media screen and (min-width: 1025px) { padding: 60px 9%; margin: 100px 0;
    padding: 0;
    width: 90vw;
    margin: 100px auto;
    max-width: 1170px;
    h2 { font-size: 46px; line-height: 72px; }
    p { width: 582px; font-size: 14px; line-height: 190%; text-align: justify; }
  }
  @media (min-width: 1180px) {width: 100%;}
`

export default Testimonials
